<template>
  <div class="block">
    <div class="radio" style="margin:10px 0;">
        排序：
        <el-radio-group v-model="reverse_notify_record_time">
        <el-radio :label="true">降冪</el-radio>
        <el-radio :label="false">升冪</el-radio>
        </el-radio-group>
    </div>
    <el-timeline :reverse="reverse_notify_record_time">
        <!-- {{id}} -->
        <!-- {{notify_record_time}} -->
      <el-timeline-item 
      v-for="(item,index) of notify_record_time" 
      :key="index" 
      :timestamp="item.notify_date_time"
      >
      <!--       style="white-space:pre-wrap;" -->
        <!-- <el-card>
          <h4>{{ item.title }}</h4>
          <p>{{ item.content }}</p>
        </el-card> -->
        {{ item.notify_message }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getNotifyRecord } from '@/api/log_manager'
export default {
  name: "notifyrecord",
  data() {
    return {
      notify_record_time: [],
      reverse_notify_record_time: false
    }
  },
  computed: {
    ...mapGetters([
      'id'
    ])
  },
  mounted() {
    this.getNotifyRecord()
  },
  methods: {
      getNotifyRecord() {
          var payload = ''
          payload += 'admin_id=' + this.id
          getNotifyRecord(payload).then((resp)=>{
              this.notify_record_time = resp.data.list
          })
      }
  },
}
</script>
